export const socialsData = {
    github: 'https://github.com/SanketJ29',
    linkedIn: 'https://www.linkedin.com/in/sanketjaiswal29/',
    instagram: 'https://www.instagram.com/sanketjaiswal29/',
    envelope: 'https://mail.google.com/mail/?view=cm&fs=1&to=sanketjaiswal2912@gmail.com',
}